module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO13FlujoDedEfectivo(ant44).70027cb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO13FlujoDedEfectivo(ant44).mp4
// module id = 739
// module chunks = 1